import { observer } from 'mobx-react-lite'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import useMediaQuery from '@mui/material/useMediaQuery'

import { Icon } from '@mxenabled/mxui'

import { useGlobalCopyStore } from '../../../common'

interface AddAccountsProps {
  handleConnectClick: () => void
}

const AddAccounts = ({ handleConnectClick }: AddAccountsProps) => {
  const { common: copy } = useGlobalCopyStore()
  const isSmallerThan700 = useMediaQuery('(max-width: 700px)')

  return (
    <Box>
      {isSmallerThan700 ? (
        <Tooltip id="add-accounts" placement="bottom" title={copy.add_accounts}>
          <IconButton
            aria-controls="add_accounts"
            aria-describedby="add-accounts"
            aria-haspopup={true}
            aria-label={copy.add_accounts}
            color="primary"
            onClick={handleConnectClick}
          >
            <Icon name="add" size={24} />
          </IconButton>
        </Tooltip>
      ) : (
        <Button
          aria-controls="add_accounts"
          aria-haspopup={true}
          aria-label={copy.add_accounts}
          onClick={handleConnectClick}
          startIcon={<Icon name="add" size={24} />}
          sx={{
            p: 12,
            whiteSpace: 'nowrap',
            minWidth: 'max-content',
          }}
          variant="text"
        >
          {copy.add_accounts}
        </Button>
      )}
    </Box>
  )
}

export default observer(AddAccounts)
